<template>
  <b-row>
    <b-col
      cols="12"
      sm="12"
      class="d-flex align-items-center justify-content-between "
    >
      <div v-if="hasResults">
        Results: <span class="font-weight-bold">{{ totalRows }}</span>
      </div>
      <!-- pagination -->

      <b-pagination
        :value="page"
        :total-rows="totalRows"
        :per-page="perPage"
        align="end"
        first-number
        last-number
        :total-visible="7"
        class="mb-0 mt-1"
        prev-class="prev-item"
        next-class="next-item"
        aria-controls="my-table"
        @input="$emit('get-all-data', $event)"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    page: {
      type: Number,
      default: () => 1,
    },
    perPage: {
      type: Number,
      default: () => 20,
    },
    totalRows: {
      type: [Number, String],
      default: () => 0,
    },
    hasResults: {
      type: Boolean,
      default: () => true,
    },

  },
}
</script>
